<template>
  <div>
    <TopBar />
    <el-container>
      <el-aside width="200px">
        <SideBar />
      </el-aside>
      <el-main>
        <div class="custom-container">
          <div id="check" class="mt-3" style="border-top: 1px solid;">
            <div id="tab" class="d-flex mt-3">
              <ul class="nav nav-pills" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#全部课程">全部课程（12）</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#更新中">更新中（3）</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#已完结">已完结（3）</a>
                </li>
              </ul>
              <div class="button-container ms-auto">
                <button id="button2" class="btn btn-primary">按时间</button>
                <button id="button3" class="btn btn-primary">按章节</button>
              </div>
            </div>

            <div class="tab-content">
              <div id="全部课程" class="container tab-pane active">
                <div class="video-grid" id="video-list"></div>
              </div>
              <div id="更新中" class="container tab-pane">
                <div class="video-grid" id="update-video-list"></div>
              </div>
              <div id="已完结" class="container tab-pane">
                <div class="video-grid" id="completed-video-list"></div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar.vue';
import TopBar from '@/components/TopBar.vue';

export default {
  name: 'ReleaseClass',
  data() {
    return {
      videos: [
        {
          title: "视频 1",
          status: "更新中",
          date: "2024-09-01",
          views: 123,
          src: "/videos/1.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/3.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/4.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/6.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/5.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/6.mp4"
        },
        {
          title: "视频 2",
          status: "已完结",
          date: "2024-08-15",
          views: 456,
          src: "/videos/7.mp4"
        }
      ]
    };
  },
  components: {
    SideBar,
    TopBar
  },
  methods: {
    generateVideoHTML(video) {
      return `
        <div class="video-item">
          <div class="video-container">
            <video src="${video.src}" controls></video>
            <div class="video-overlay">
              <button class="play-button"><i class="fas fa-play"></i></button>
            </div>
          </div>
          <div class="video-description">
            <div class="video-title">${video.title}</div>
            <div class="video-meta">
              <span class="video-date"><i class="fas fa-calendar-day"></i> ${video.date}</span>
              <span class="video-views"><i class="fas fa-users"></i> ${video.views}</span>
              <span class="video-status"><i class="fas fa-lock"></i> ${video.status}</span>
            </div>
          </div>
        </div>
      `;
    },
    populateVideos(containerId, filterStatus) {
      const container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = '';
        this.videos.forEach(video => {
          if (!filterStatus || video.status === filterStatus) {
            container.innerHTML += this.generateVideoHTML(video);
          }
        });
      }
    }
  },
  mounted() {
    this.populateVideos("video-list");
    this.populateVideos("update-video-list", "更新中");
    this.populateVideos("completed-video-list", "已完结");
  }
};
</script>

<style >
/* 视频列表容器 */
.video-grid {
  display: flex; /* Change display to flex */
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  gap: 16px;
  padding: 16px;
  /* Remove grid-template-columns and media queries */
}

/* 视频项样式 */
.video-item {
  /* Add fixed width and height */
  width: 250px; /* Example fixed width */
  height: 220px; /* Example fixed height, adjust as needed */
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.video-container {
  position: relative;
  overflow: hidden;
  /* Ensure video container takes available space but respects video aspect ratio */
  flex-grow: 1; 
}

.video-container video {
  width: 100%;
  /* Set a max-height or height: auto to maintain aspect ratio within the container */
  height: 150px; /* Fixed height for the video player itself */
  object-fit: cover; /* Cover the area, might crop */
}

.video-description {
  padding: 10px;
  /* Prevent description from shrinking */
  flex-shrink: 0;
}

.video-title {
  font-size: 1rem;
  font-weight: bold;
  /* Prevent long titles from breaking layout */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 5px; /* Add some space above meta */
}

.video-meta span i {
  margin-right: 4px;
}
</style>
